<template>
  <div class="update-client-profile">
    <div class="update-client-profile-wrap">
      <b-card no-body class="update-client-profile-b-card">
        <b-card-header class="statistics-filter-header">
          Filtro
        </b-card-header>
        <b-card-body class="client-profile-update-body">
          <b-overlay class="custom-overlay" :show="displayOverlay" rounded="sm">
            <div class="client-profile-update-filters">
              <div class="flex col-md-6 calendar-client-profile">
                <flat-pickr
                  v-model="rangePicker"
                  class="form-control-sm form-date"
                  :placeholder="$t('MANAGE_NEWS_FILTER.Period')"
                  :config="{
                    enableTime: false,
                    dateFormat: 'Y-m-d',
                    altInput: true,
                    altFormat: 'd/m/Y',
                    allowInput: true,
                    mode: 'range',
                  }"
                />
                <!-- <feather-icon icon="CalendarIcon" size="16" /> -->
              </div>
              <div class="col-md-6 client-filter">
                <b-form-group>
                    <b-form-input 
                      v-model="emailModel" 
                      label="name" 
                      :placeholder="$t('MANAGE_CLIENTS_FILTER.Email')" 
                      @keyup.enter="fetchClientProfileUpdate"
                    >
                      <span slot="no-options"></span>
                  </b-form-input>
                </b-form-group>
              </div>
              <div class="col-md-6 client-filter">
                <b-form-group>
                  <v-select 
                    v-model="fromProfileModel" 
                    label="name" 
                    :options="fromProfileOptions" 
                    :placeholder="$t('STATISTICS.From_Profile')" 
                    :reduce="option => option.id"  
                    @input="fetchClientProfileUpdate"
                  >
                    <span slot="no-options">{{ $t("GENERAL.NoOptions") }}</span>
                  </v-select>
                </b-form-group>
              </div>
              <div class="col-md-6 client-filter">
                <b-form-group>
                  <v-select 
                    v-model="toProfileModel" 
                    label="name" 
                    :options="toProfileOptions" 
                    :placeholder="$t('STATISTICS.To_Profile')" 
                    :reduce="option => option.id"  
                    @input="fetchClientProfileUpdate"
                  >
                    <span slot="no-options">{{ $t("GENERAL.NoOptions") }}</span>
                  </v-select>
                </b-form-group>
              </div>
            </div>
            <div class="report-buttons">
              <b-button
                class="search-button"
                variant="primary"
                size="sm"
                @click="fetchClientProfileUpdate()"
              >
                <feather-icon icon="SearchIcon" class="export-button-icon"/>
                {{ $t("MANAGE_NEWS_FILTER.Search") }}
              </b-button>
              <b-button
                variant="primary"
                size="sm"
                @click="reportData()"
              >
                <feather-icon icon="FileTextIcon" class="export-button-icon"/>
                Exportar
              </b-button>
              <b-button 
                variant="primary"
                size="sm" 
                @click="onClear"
              >
                <feather-icon icon="TrashIcon"/>
                {{ $t('MANAGE_NEWS_FILTER.Clear') }}
              </b-button>
            </div>

            <div class="table-client-profile">
              <custom-g-table
                v-if="displayTable"
                ref="custom-table"
                :fields="fields"
                :items="updateClientProfile"
                :totalRows="totalRows"
                :limit="limit"
                :tableMaxHeight="tableMaxHeight"
                @changePage="onChangePage"
              />
            </div>
          </b-overlay>
        </b-card-body>
      </b-card>
    </div>
  </div>
</template>

<script>
import {
  BCard,
  BCardBody,
  BCardHeader,
  BButton,
  BOverlay,
  BFormGroup,
  BFormInput,
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
// import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { ref, watch } from "@vue/composition-api";
// import convertDatetimeHelper from '@/helpers/convert-datetime-helper';
import AppConstants from "@/appConstants";
import vSelect from "vue-select";
import dropdownService from "@/providers/dropdownService";
import clientService from "@/providers/clientService";
import CustomGTable from "@/views/custom/table/CustomGTable.vue";
import { useWindowSize } from "@vueuse/core";
import messagesNotifyHelper from '@/helpers/messages-notify-helper';

export default {
  components: {
    // VuePerfectScrollbar,
    BCard,
    BCardBody,
    BCardHeader,
    flatPickr,
    BButton,
    BOverlay,
    BFormGroup,
    BFormInput,
    vSelect,
    CustomGTable
  },
  setup() {
    const toProfileOptions = ref([]);
    const fromProfileOptions = ref([]);
    const fromProfileModel = ref(null);
    const toProfileModel = ref(null);
    const emailModel = ref(null);
    const displayOverlay = ref(false);
    // const rangePicker = ref(convertDatetimeHelper.getDateRangeFilterFormat());
    const rangePicker = ref("");
    const updateClientProfile = ref([]);
    const limit = ref(AppConstants.PAGINATOR_DEFAULT_LIMIT);
    // const limit = ref(15);
    const page = ref(1);
    const totalRows = ref(0);

    const fields = [
      { field: "email", label: "Email", sortable: false },
      { field: "name", label: "Nome", sortable: false },
      { field: "phone.ddd", label: "DDD", sortable: false },
      { field: "phone.number", label: "Telefone", sortable: false },
      { field: "cnpj_cpf", label: "Documento", sortable: false },
      { field: "origin", label: "Origem", type: "array", sortable: false },
      { field: "from_profile", label: "De Perfil", sortable: false },
      { field: "to_profile", label: "Para Perfil", sortable: false },
      { field: "dt_create", label: "Data Criação", type: "custom_date", sortable: false },
      { field: "dt_update", label: "Data Atualização", type: "custom_date", sortable: false },
      { field: "_id", label: "ID do Cliente", sortable: false },
    ];
    const displayTable= ref(false);

    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelSpeed: 0.3,
      swipeEasing: true,
    };

    const onChangePage = (newPage) => {
      page.value = newPage;
      fetchClientProfileUpdate();
    };

    const formatClientProfileData = (data) => {
      return data.map(item => ({
        ...item,
        origin: item.origin ? [item.origin] : [],
        from_profile: getProfileName(item.from_profile),
        to_profile: getProfileName(item.to_profile)
      }));
    };

    const getProfileName = (profileId) => {
      const profile = fromProfileOptions.value.find(p => p.id === profileId);
      return profile ? profile.name : '';
    };

    const fetchClientProfileUpdate = () => {
      displayOverlay.value = true;

      const params = new URLSearchParams();

      params.append("page", page.value);
      params.append("limit", limit.value);
      // params.append("limit", 2);

      if (rangePicker.value) {
        params.append("dt_range", rangePicker.value);
      }
      if (emailModel.value) {
        params.append("email", emailModel.value);
      }
      if (fromProfileModel.value) {
        params.append("from_profile", fromProfileModel.value);
      }
      if (toProfileModel.value) {
        params.append("to_profile", toProfileModel.value);
      }
      clientService.getUpdateClientProfile(params)
        .then(res => {
          updateClientProfile.value = formatClientProfileData(res.data);
          totalRows.value = res.totalRows;
          displayTable.value = true;
        })
        .catch(err => console.error('Error fetching update client profile:', err))
        .finally(() => {
          displayOverlay.value = false;
        });
    };

    const reportData = () => {
      const params = new URLSearchParams();
      params.append('page', page.value);
      params.append('limit', limit.value);
      
      if (rangePicker.value) {
        params.append("dt_range", rangePicker.value);
      }
      if (!rangePicker.value || rangePicker.value <= 0) {
        messagesNotifyHelper.errorNotify(
          "Erro",
          "Sem dados para exportar, verifique sua pesquisa e tente novamente"
        );
        return;
      }
      params.append("download", true);
      clientService
        .reportUpdateClientProfile(params)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");

          link.href = url;
          link.setAttribute("download", 'relatorio_atualizacao_de_perfil_do_cliente.xlsx');
          link.setAttribute("id", "link-download");

          document.body.appendChild(link);
          link.click();

          document.getElementById("link-download").remove();
        })
        .catch((err) => console.log(err));
    };

    const loadDataFilter = () => {
      dropdownService.getAllClientProfile(new URLSearchParams())
      .then(res => {
        fromProfileOptions.value = res;
        toProfileOptions.value = res;
      })
      .catch((err) => console.log(err));
    };

    const onClear= () => {
      rangePicker.value = "";
      emailModel.value = null;
      fromProfileModel.value = null;
      toProfileModel.value = null;
    };

    const tableMaxHeight = ref(AppConstants.CUSTOM_TABLE_DEFAULT_HEIGHT);
    const { height: windowheight } = useWindowSize();
    watch(windowheight, (val) => {
      if (val < 900) {
        tableMaxHeight.value = '200px';
      } else {
        tableMaxHeight.value = AppConstants.CUSTOM_TABLE_DEFAULT_HEIGHT;
      }
    },  { immediate: true });

    loadDataFilter();

    return {
      limit,
      totalRows,
      onChangePage,
      updateClientProfile,
      displayOverlay,
      perfectScrollbarSettings,
      rangePicker,
      reportData,
      emailModel, 
      fromProfileModel,
      toProfileModel,
      fromProfileOptions,
      toProfileOptions,
      loadDataFilter,
      fetchClientProfileUpdate,
      fields,
      displayTable,
      onClear,
      tableMaxHeight
    };
  },
};
</script>

<style scoped >
.client-profile-update-body {
  display: flex;
  flex-direction: column;
}
.client-profile-update-body .align-items-center {
  margin-bottom: 20px;
  width: auto;
}

.client-profile-update-body .form-date {
  margin-right: 20px;
}

.search-button {
  margin-right: 10px;
}

.export-button-icon {
  height: 13px;
  width: 13px;
}

.calendar-client-profile {
  margin-bottom: 15px;
  align-items: center;
}

.report-buttons {
  padding: .5rem;
}

.update-client-profile {
  height: 100%;
  width: 100%;
}

.update-client-profile .custom-overlay {
  height: 100%;
  width: 100%;
}

.update-client-profile-b-card {
  height: 100%;
  width: 100%;
}

/* .update-client-profile .col-md-12 {
  height: 100%;
  width: 100%;
} */

.update-client-profile-wrap {
  height: 100%;
  width: 100%;
}

.vue-g-table .vgt-table {
  max-height: 20% !important;
}

.client-profile-update-filters {
  display: flex;
  flex-wrap: wrap;
}

.calendar-client-profile svg{
  margin-right: 5px;
}

.report-buttons button {
  margin-right: 10px;
}

</style>